import { getFileFormatInfo } from './fileFormat';

export function isAudioLikeFile(file: File): boolean {
  return (
    getFileFormatInfo(file.name).isAudio ||
    file.type.startsWith('audio/') ||
    file.type.startsWith('video/')
  );
}

/** Paper 58W — e.g. "24 min 32 sec" */
export function formatAudioDurationForChat(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0 || seconds >= 86400) return '';
  const s = Math.floor(seconds % 60);
  const m = Math.floor((seconds % 3600) / 60);
  const h = Math.floor(seconds / 3600);
  if (h > 0) return `${h} hr ${m} min ${s} sec`;
  if (m > 0) return `${m} min ${s} sec`;
  return `${s} sec`;
}

/** System line before duration metadata is known (single file). */
export function singleFileLoadedMessageBase(fileName: string): string {
  return `[${fileName}] loaded. What would you like to do with it?`;
}

/** Paper 5SJ-0 — single PDF loaded with optional page count. */
export function pdfSingleFileLoadedMessage(fileName: string, pageCount?: number): string {
  if (pageCount && pageCount > 0) {
    return `${fileName} loaded — ${pageCount} pages. What would you like to do?`;
  }
  return `${fileName} loaded. What would you like to do with it?`;
}

export function singleFileLoadedMessageWithDuration(fileName: string, durationLabel: string): string {
  return `[${fileName}] loaded — ${durationLabel}. What would you like to do with it?`;
}

/** Paper 58W — chat rail chips + input pills when a single audio/video file is in doc view */
export const AUDIO_CHAT_QUICK_ACTIONS: readonly { label: string; prompt: string }[] = [
  {
    label: 'Transcribe & key moments',
    prompt: 'Transcribe this recording and give me the key moments with timestamps.',
  },
  {
    label: 'Summarize recording',
    prompt: 'Summarize this recording in clear sections. Include approximate timestamps where helpful.',
  },
  {
    label: 'Action items',
    prompt: 'List concrete action items and next steps mentioned in this recording.',
  },
];

/** Paper 58I — document column footer (Transcribe · Summarize · Key moments · + Ask) */
export const AUDIO_DOCUMENT_BOTTOM_ACTIONS: readonly { label: string; prompt: string | null }[] = [
  { label: 'Transcribe', prompt: 'Transcribe this recording.' },
  {
    label: 'Summarize',
    prompt: 'Summarize this recording in clear sections. Include approximate timestamps where helpful.',
  },
  { label: 'Key moments', prompt: 'Give me the key moments from this recording with timestamps.' },
  { label: '+ Ask', prompt: null },
];
